export const GIVING_LINK_BUTTON_LABEL = 'giving-link-button.label';
